/* RenzoBoggio Estudio — JS mínimo sin dependencias.
   Carrito lateral, búsqueda predictiva, variantes, barra de compra móvil y eventos de analítica. */
(() => {
  const RB = window.RB || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ---------- Formato de dinero ---------- */
  const money = (cents) => {
    const fmt = RB.moneyFormat || 'S/. {{amount}}';
    const amount = (cents / 100).toFixed(2);
    const withSep = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount\s*\}\}/, withSep);
  };
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- Analítica: eventos personalizados (los recoge el píxel personalizado) ---------- */
  const track = (name, data = {}) => {
    try { window.Shopify?.analytics?.publish?.(name, data); } catch (e) { /* sin analítica en vista previa */ }
  };
  document.addEventListener('click', (e) => {
    const el = e.target.closest('[data-rb-event]');
    if (el) track(el.dataset.rbEvent, { label: el.dataset.rbLabel || '', url: el.href || '' });
  });
  $$('form[data-rb-form]').forEach((f) => f.addEventListener('submit', () => track('rb_form_submit', { form: f.dataset.rbForm })));
  if (document.querySelector('[data-rb-form-success]')) track('rb_form_success', { form: document.querySelector('[data-rb-form-success]').dataset.rbFormSuccess });

  /* ---------- Diálogos ---------- */
  let lastTrigger = null;
  const openDialog = (id) => {
    const d = document.getElementById(id);
    if (!d || d.open) return;
    lastTrigger = document.activeElement;
    d.showModal();
    if (id === 'search-drawer') setTimeout(() => $('[data-predictive-input]')?.focus(), 30);
    if (id === 'cart-drawer') renderCart();
  };
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) { e.preventDefault(); openDialog(opener.dataset.open); return; }
    const closer = e.target.closest('[data-close]');
    if (closer) { closer.closest('dialog')?.close(); return; }
    if (e.target.tagName === 'DIALOG') e.target.close(); // clic en el fondo
  });
  $$('dialog').forEach((d) => d.addEventListener('close', () => lastTrigger?.focus?.()));

  /* ---------- Carrito ---------- */
  const setCount = (n) => $$('[data-cart-count]').forEach((el) => { el.textContent = n; el.hidden = n === 0; });
  const freebar = (total) => {
    const box = $('[data-freebar]');
    if (!box) return;
    const fs = RB.freeShipping || {};
    if (!fs.enabled || fs.country !== 'PE' || !total) { box.innerHTML = ''; return; }
    const left = fs.threshold - total;
    const pct = Math.min(100, Math.round((total / fs.threshold) * 100));
    box.innerHTML = `<div class="freebar">${left > 0 ? esc(RB.t.free_left).replace('[amount]', money(left)) : esc(RB.t.free_ok)}<div class="freebar__track"><div class="freebar__fill" style="width:${pct}%"></div></div></div>`;
  };
  const renderCart = async () => {
    const wrap = $('[data-cart-items]');
    if (!wrap) return;
    const cart = await fetch(`${RB.routes.cart}.js`).then((r) => r.json());
    setCount(cart.item_count);
    $('[data-cart-subtotal]').textContent = money(cart.total_price);
    $('[data-cart-checkout]').disabled = cart.item_count === 0;
    freebar(cart.total_price);
    if (!cart.items.length) { wrap.innerHTML = `<p>${esc(RB.t.empty)}</p>`; return; }
    wrap.innerHTML = cart.items.map((it, i) => `
      <div class="line-item">
        ${it.image ? `<img src="${esc(it.image.replace(/(\.\w+)(\?|$)/, '_200x$1$2'))}" alt="" width="72" height="88" loading="lazy">` : '<span></span>'}
        <div>
          <a class="line-item__title" href="${esc(it.url)}">${esc(it.product_title)}</a>
          ${it.variant_title ? `<p class="small">${esc(it.variant_title)}</p>` : ''}
          <div class="qty" style="margin-top:.4rem;">
            <button type="button" data-line="${i + 1}" data-qty="${it.quantity - 1}" aria-label="${esc(RB.t.decrease)}">−</button>
            <input type="number" value="${it.quantity}" min="0" aria-label="${esc(it.product_title)}" readonly>
            <button type="button" data-line="${i + 1}" data-qty="${it.quantity + 1}" aria-label="${esc(RB.t.increase)}">+</button>
          </div>
          <button class="link-btn" type="button" data-line="${i + 1}" data-qty="0">${esc(RB.t.remove)}</button>
        </div>
        <strong class="small">${money(it.final_line_price)}</strong>
      </div>`).join('');
  };
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-line]');
    if (!b) return;
    await fetch(`${RB.routes.cart_change}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: Number(b.dataset.line), quantity: Number(b.dataset.qty) }) });
    renderCart();
  });

  /* Agregar al carrito sin recargar (con respaldo nativo si falla JS) */
  $$('form[data-product-form]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      btn.disabled = true;
      try {
        const res = await fetch(`${RB.routes.cart_add}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!res.ok) throw new Error((await res.json()).description || RB.t.error);
        $('[data-cart-status]').textContent = RB.t.added;
        openDialog('cart-drawer');
      } catch (err) {
        alert(err.message || RB.t.error);
      } finally {
        btn.disabled = false;
        updateVariant(form);
      }
    });
  });

  /* ---------- Variantes ---------- */
  function updateVariant(form) {
    const dataEl = form.querySelector('[data-variants]');
    if (!dataEl) return;
    const variants = JSON.parse(dataEl.textContent);
    const chosen = $$('[data-option-index]', form).filter((i) => i.checked).map((i) => i.value);
    const v = variants.find((x) => x.options.every((o, idx) => o === chosen[idx])) || null;
    const idInput = form.querySelector('[name="id"]');
    const btns = $$('[data-add-button]');
    if (v) idInput.value = v.id;
    btns.forEach((btn) => {
      btn.disabled = !v || !v.available;
      btn.textContent = !v ? RB.t.unavailable : v.available ? RB.t.add : RB.t.sold_out;
    });
    if (v) {
      const tpl = $(`template[data-price-for="${v.id}"]`);
      if (tpl) $$('[data-variant-price]').forEach((p) => { p.innerHTML = tpl.innerHTML; });
      if (v.featured_media_id) showMedia(String(v.featured_media_id));
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState(null, '', url);
    }
  }
  $$('form[data-product-form]').forEach((form) => {
    form.addEventListener('change', (e) => { if (e.target.matches('[data-option-index]')) updateVariant(form); });
  });

  /* Galería */
  function showMedia(id) {
    const main = $('[data-gallery-main]');
    const src = $(`[data-media-id="${id}"]`);
    if (!main || !src) return;
    main.innerHTML = src.querySelector('template').innerHTML;
    $$('[data-media-id]').forEach((b) => b.setAttribute('aria-current', String(b.dataset.mediaId === id)));
  }
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-media-id]');
    if (t) showMedia(t.dataset.mediaId);
  });

  /* Cantidad */
  document.addEventListener('click', (e) => {
    const step = e.target.closest('[data-step]');
    if (!step) return;
    const input = step.parentElement.querySelector('input');
    input.value = Math.max(1, Number(input.value || 1) + Number(step.dataset.step));
  });

  /* Barra de compra fija en móvil */
  const buy = $('[data-buy-anchor]');
  const sticky = $('[data-sticky-buy]');
  if (buy && sticky && 'IntersectionObserver' in window) {
    document.body.classList.add('has-sticky-buy');
    new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0)).observe(buy);
    sticky.querySelector('button')?.addEventListener('click', () => $('form[data-product-form] [type="submit"]')?.click());
  }

  /* ---------- Búsqueda predictiva ---------- */
  const qInput = $('[data-predictive-input]');
  const qOut = $('[data-predictive-results]');
  let ctrl;
  qInput?.addEventListener('input', () => {
    const q = qInput.value.trim();
    ctrl?.abort();
    if (q.length < 2) { qOut.innerHTML = ''; return; }
    ctrl = new AbortController();
    fetch(`${RB.routes.predictive}.json?q=${encodeURIComponent(q)}&resources[type]=product,page&resources[limit]=6`, { signal: ctrl.signal })
      .then((r) => r.json())
      .then(({ resources }) => {
        const prods = (resources.results.products || []).filter((p) => !(RB.hidden || []).includes(p.handle));
        const pages = resources.results.pages || [];
        if (!prods.length && !pages.length) { qOut.innerHTML = `<p>${esc(RB.t.no_results)}</p>`; return; }
        qOut.innerHTML = `<ul>${prods.map((p) => `<li><a href="${esc(p.url)}">${p.image ? `<img src="${esc(p.image)}" alt="" width="56" height="68" loading="lazy">` : '<span></span>'}<span><strong>${esc(p.title)}</strong><br><span class="small">${esc(p.price ? money(Math.round(Number(p.price) * 100)) : '')}</span></span></a></li>`).join('')}${pages.map((p) => `<li><a href="${esc(p.url)}"><span></span><span><strong>${esc(p.title)}</strong></span></a></li>`).join('')}</ul>`;
      })
      .catch(() => {});
  });

  /* ---------- Selector de país/idioma ---------- */
  $$('[data-autosubmit]').forEach((s) => s.addEventListener('change', () => s.form.submit()));

  /* Contador inicial del carrito */
  if (document.readyState !== 'loading') freebarInit(); else document.addEventListener('DOMContentLoaded', freebarInit);
  function freebarInit() { fetch(`${RB.routes.cart}.js`).then((r) => r.json()).then((c) => { setCount(c.item_count); freebar(c.total_price); }).catch(() => {}); }
})();
